import { useState } from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { ReportIssueDialog } from './ReportIssueDialog';

/**
 * Lives in the header rather than behind a route: the people most likely to hit
 * a bug are standard-role users, who can only reach five paths. A page they
 * cannot navigate to is not an intake channel.
 */
export function ReportIssueButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Report a problem or request a feature"
        className="inline-flex h-9 items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 sm:px-3"
      >
        <MessageSquarePlus className="h-4 w-4 flex-shrink-0" />
        <span className="hidden lg:inline">Report</span>
      </button>
      {/* Mounted only while open. The dialog reads the router for the route it
          attaches to a report, so keeping it mounted would make the whole
          header require a Router even when nobody is filing anything. */}
      {open && <ReportIssueDialog open onClose={() => setOpen(false)} />}
    </>
  );
}
